export var NumberFormatKind;
(function (NumberFormatKind) {
    NumberFormatKind[NumberFormatKind["percent"] = 0] = "percent";
    NumberFormatKind[NumberFormatKind["compact"] = 1] = "compact";
    NumberFormatKind[NumberFormatKind["currency"] = 2] = "currency";
    NumberFormatKind[NumberFormatKind["multiple"] = 3] = "multiple";
    NumberFormatKind[NumberFormatKind["default"] = 4] = "default";
    NumberFormatKind[NumberFormatKind["area"] = 5] = "area";
    NumberFormatKind[NumberFormatKind["unit"] = 6] = "unit";
})(NumberFormatKind || (NumberFormatKind = {}));
